import ozToggle from '@/components/oz-toggle'

const ZAPWAY = 'zapway'

export default {
  name: 'oz-toggle-zapway',

  props: {
    warranties: { type: String, default: '' },
    isPill: { type: Boolean, default: false },
  },

  data () {
    return {
      initialValue: false,
    }
  },

  created () {
    this.initialValue = this.hasZapway(this.warranties)
  },

  watch: {
    warranties () {
      this.initialValue = this.hasZapway(this.warranties)
    },
  },

  methods: {
    dismountWarranties (warrantiesValue) {
      const warranties = warrantiesValue ? warrantiesValue.split(',') : []
      const zapwayIndex = warranties.findIndex((el) => el === ZAPWAY)

      return { size: warranties.length, zapwayIndex, warranties }
    },

    hasZapway (warrantiesValue) {
      if (!warrantiesValue) return false

      const { size, zapwayIndex } = this.dismountWarranties(warrantiesValue)

      if (!size) return false

      if (zapwayIndex >= 0) return true

      return false
    },

    updateZapway (zapwayBoolean) {
      const toggleZapway = zapwayBoolean
      const { zapwayIndex, warranties } = this.dismountWarranties(this.warranties)
      this.initialValue = toggleZapway
      const filters = { warranties }

      const applyZapway = () => {
        filters.warranties.push(ZAPWAY)
      }

      if (zapwayIndex >= 0) {
        if (toggleZapway) {
          applyZapway()
        } else {
          filters.warranties.splice(zapwayIndex, 1)
        }
      } else if (toggleZapway) {
        applyZapway()
      }
      filters.warranties = filters.warranties.toString()
      this.$emit('filters:update', filters, 'warranties')
    },
  },

  components: {
    ozToggle,
  },
}
